var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Gruppe_79","data-name":"Gruppe 79","transform":"translate(-342.507 -339.712)"},[React.createElement("circle",{"id":"Ellipse_3","data-name":"Ellipse 3","cx":"15.326","cy":"15.326","r":"15.326","transform":"translate(343.507 340.713)","fill":"none","stroke":"#161615","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":0}),React.createElement("path",{"id":"Pfad_16","data-name":"Pfad 16","d":"M384.181,350.825v11.516l-7.949,3.035","transform":"translate(-25.347 -4.302)","fill":"none","stroke":"#161615","strokeLinecap":"round","strokeLinejoin":"round","strokeWidth":"2","key":1})]));
}

Clock.defaultProps = {"width":"28","height":"28","viewBox":"0 0 32.653 32.653"};

module.exports = Clock;

Clock.default = Clock;
